import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FileType } from '@/types/types';

export type UploadIntent = {
  targetPath: string; // e.g. /app/pdf?tool=merge
  toolType?: string;
  fileTypes?: FileType[];
  multiple?: boolean;
};

interface UploadState {
  intent: UploadIntent | null;
  suppressedUploadAnimSource: string | null;
}

const initialState: UploadState = {
  intent: null,
  suppressedUploadAnimSource: null,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setUploadIntent(state, action: PayloadAction<UploadIntent>) {
      state.intent = action.payload;
    },
    clearUploadIntent(state) {
      state.intent = null;
    },
    setSuppressedUploadAnimSource(state, action: PayloadAction<string | null>) {
      state.suppressedUploadAnimSource = action.payload;
    },
    clearSuppressedUploadAnimSource(state) {
      state.suppressedUploadAnimSource = null;
    },
  },
});

export const {
  setUploadIntent,
  clearUploadIntent,
  setSuppressedUploadAnimSource,
  clearSuppressedUploadAnimSource,
} = uploadSlice.actions;
export default uploadSlice.reducer;
